import React from "react";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import LocalAtmOutlinedIcon from "@material-ui/icons/LocalAtmOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import { PAYMENT_OPTIONS } from "./constants";

export const formatNumber = (str, style) => {
  if (str === "") return "";
  else return Number(str).toLocaleString("es-CL", { style, currency: "CLP" });
};

export const unformatNumber = number => number.toString().replace(/\$/g, "").replace(/\./g, "");

export const formatRut = rut => {
  let formatted = rut.toUpperCase();

  if (rut.length > 1) {
    try {
      const number = rut.substring(0, rut.length - 1);
      const dv = rut.charAt(rut.length - 1);

      formatted = `${formatNumber(number, "decimal")}-${dv}`;
    } catch (err) {}
  }

  return formatted;
};

export const nombreEsValido = nombre => {
  const rgxNombre = new RegExp(/^[a-zA-Z' \-áéíóúÁÉÍÓÚñÑäÄëËïÏöÖüÜ]+$/);
  return rgxNombre.test(nombre);
};

export const unformatRut = rut => rut.toUpperCase().replace(/[^0-9K]/g, "");

const calculateDV = rut => {
  const cuerpo = `${rut}`;

  // Calcular Dígito Verificador
  let suma = 0;
  let multiplo = 2;

  // Para cada dígito del Cuerpo
  for (let i = 1; i <= cuerpo.length; i++) {
    // Obtener su Producto con el Múltiplo Correspondiente
    const index = multiplo * cuerpo.charAt(cuerpo.length - i);

    // Sumar al Contador General
    suma += index;

    // Consolidar Múltiplo dentro del rango [2,7]
    if (multiplo < 7) {
      multiplo += 1;
    } else {
      multiplo = 2;
    }
  }

  // Calcular Dígito Verificador en base al Módulo 11
  const dvEsperado = 11 - (suma % 11);
  if (dvEsperado === 10) return "K";
  if (dvEsperado === 11) return "0";
  return `${dvEsperado}`;
};

const repeatChar = (char, times) => {
  let chars = "";
  let len = times;

  while (len--) {
    chars += char;
  }

  return chars;
};

const isRutCharRepeated = rut => {
  let char = 10;

  while (char--) {
    let chars = repeatChar(char.toString(), 7);
    if (rut === chars) return true;

    chars += char.toString();
    if (rut === chars) return true;

    chars += char.toString();
    if (rut === chars) return true;
  }

  return false;
};

export const rutEsValido = rut => {
  const rutLimpio = unformatRut(rut);

  if (rutLimpio.length < 7) return false;
  if (isRutCharRepeated(rutLimpio)) return false;

  const num = rutLimpio.substring(0, rutLimpio.length - 1);
  const dgv = rutLimpio.charAt(rutLimpio.length - 1);

  const dvCalc = calculateDV(num);
  return dvCalc === dgv;
};

export const formatCelular = numero => {
  let str = unformatCelular(numero);
  let parte1 = "";
  let parte2 = "";

  if (str.length > 4) {
    parte1 = str.substring(0, 4);
    parte2 = str.substring(4);

    return `+56 9 ${parte1} ${parte2}`;
  }

  return `+56 9 ${str}`;
};

export const unformatCelular = celular =>
  (celular || "")
    .toString()
    .replace(/[^0-9+]/g, "")
    .replace("+569", "");

export const formatDate = date =>
  new Date(date).toLocaleDateString("es-CL", {
    dateStyle: "medium",
    timeZone: "UTC"
  });

export const toTitleCase = str =>
  (str || "")
    .toString()
    .replace(/^\w/g, c => c.toUpperCase())
    .replace(/ {1,}\w/g, c => c.toUpperCase());

export const validateEmail = email => {
  const rgxEmail = new RegExp(/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/);

  return rgxEmail.test(email);
};

export const removeEmptyStringElements = obj => {
  for (var prop in obj) {
    if (typeof obj[prop] === "object") {
      removeEmptyStringElements(obj[prop]);
    } else if (obj[prop] === "") {
      delete obj[prop];
    }
  }
};

export const hoy = () => {
  const today = new Date();
  const mes = today.getMonth() + 1;
  const dia = today.getDate();

  return `${today.getFullYear()}-${mes < 10 ? "0" : ""}${mes}-${dia < 10 ? "0" : ""}${dia}`;
};

export const getPaymentInfo = (option, selected) => {
  let info = {};
  switch (option) {
    case PAYMENT_OPTIONS.payku_webpay:
      info.logo = "logo-webpay-plus.png";
      info.title = "WebPay Plus";
      info.subtitle = "Tarjetas de crédito y débito bancarias";
      info.description = "Visa, MasterCard, Magna, American, Diners y Redcompra";
      info.selected = selected === PAYMENT_OPTIONS.payku_webpay;
      info.type = "webpay-plus";
      info.icon = <PaymentOutlinedIcon fontSize="large" />;
      break;
    case PAYMENT_OPTIONS.payku_onepay:
      info.logo = "logo-onepay.png";
      info.title = "OnePay";
      info.subtitle = "Billetera electrónica";
      info.description = "Paga con tarjetas de crédito, sin ingresar los datos de la tarjeta";
      info.selected = selected === PAYMENT_OPTIONS.payku_onepay;
      info.type = "onepay";
      info.icon = <PaymentOutlinedIcon fontSize="large" />;
      break;
    case PAYMENT_OPTIONS.payku_khipu:
      info.logo = "logo-khipu.png";
      info.title = "Khipu";
      info.subtitle = "Paga con tu banco";
      info.description = "Utiliza tu banco, simplifica tus transferencias";
      info.selected = selected === PAYMENT_OPTIONS.payku_khipu;
      info.type = "khipu";
      info.icon = <AccountBalanceOutlinedIcon fontSize="large" />;
      break;
    case PAYMENT_OPTIONS.contraentrega:
      info.logo = "pago-contra-entrega.png";
      info.title = "Contra Entrega";
      info.subtitle = undefined;
      info.description = "Paga al recibir el pedido";
      info.selected = selected === PAYMENT_OPTIONS.contraentrega;
      info.type = "contra-entrega";
      info.icon = <LocalAtmOutlinedIcon fontSize="large" />;
      break;
    case PAYMENT_OPTIONS.transferencia:
      info.logo = "transferencia.png";
      info.title = "Transferencia";
      info.subtitle = undefined;
      info.description = "Paga con transferencia bancaria";
      info.selected = selected === PAYMENT_OPTIONS.transferencia;
      info.type = "transferencia";
      info.icon = <AccountBalanceOutlinedIcon fontSize="large" />;
      break;
    default:
      info = null;
      break;
  }
  return info;
};

export const getPaymentTitle = type => {
  switch (type) {
    case "webpay-plus":
      return "WebPay Plus";
    case "onepay":
      return "OnePay";
    case "khipu":
      return "Khipu";
    case "contra-entrega":
      return "Contra Entrega";
    case "transferencia":
      return "Transferencia";
    default:
      return "";
  }
};

export const arrEquals = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }

  a.sort();
  b.sort();

  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};
